'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { ProductTypeSuggestion } from '@/types/searchSuggestions';
import { useImageBaseUrl } from '@/atoms/processEnvAtom';
import { SuggestionLinkItem } from '@/components/Header/SuggestionLinkItem';
import { getProductTypeImageSrc } from '@/utility/images';
import { getAssortmentDetailHrefArgs } from '@/utility/urls';
type ProductTypeSuggestionItemProps = {
  productType: ProductTypeSuggestion;
  /** Navigates to the assortment detail page — also resets the search field. */
  onNavigate: () => void;
  /** Renders the group heading above the first product type of the list. */
  showGroupLabel?: boolean;
  /** Separates the last product type from the group below. */
  showDivider?: boolean;
};
export const ProductTypeSuggestionItem = t0 => {
  const $ = _c(32);
  const {
    productType,
    onNavigate,
    showGroupLabel,
    showDivider
  } = t0;
  const t = useTranslations("header");
  const imageBaseUrl = useImageBaseUrl();
  let t1;
  if ($[0] !== productType.name || $[1] !== productType.productTypeId) {
    t1 = getAssortmentDetailHrefArgs({
      productTypeId: productType.productTypeId,
      productTypeName: productType.name
    });
    $[0] = productType.name;
    $[1] = productType.productTypeId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== showGroupLabel || $[4] !== t) {
    t2 = showGroupLabel ? t("productTypeSuggestionsLabel") : undefined;
    $[3] = showGroupLabel;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = `Searchbar - ProductType - ${productType.name}`;
  let t4;
  if ($[6] !== imageBaseUrl || $[7] !== productType.appearanceId || $[8] !== productType.productTypeId || $[9] !== productType.viewId) {
    t4 = getProductTypeImageSrc(imageBaseUrl, productType.productTypeId, productType.viewId, productType.appearanceId, undefined, undefined, 90, 120);
    $[6] = imageBaseUrl;
    $[7] = productType.appearanceId;
    $[8] = productType.productTypeId;
    $[9] = productType.viewId;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <img className="size-10 shrink-0 object-contain" src={t4} draggable={false} loading="eager" alt="" />;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("productTypeSuggestionsLabel");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <span className="sr-only">{t6}: </span>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== productType.name || $[18] !== t7) {
    t8 = <span className="min-w-24 truncate">{t7}{productType.name}</span>;
    $[17] = productType.name;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== productType.matchedTerm || $[21] !== t) {
    t9 = productType.matchedTerm && <span className="ml-auto min-w-0 truncate pl-2 text-sm text-neutral-700">{t("suggestionVia", {
        term: productType.matchedTerm
      })}</span>;
    $[20] = productType.matchedTerm;
    $[21] = t;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== onNavigate || $[24] !== showDivider || $[25] !== t1 || $[26] !== t2 || $[27] !== t3 || $[28] !== t5 || $[29] !== t8 || $[30] !== t9) {
    t10 = <SuggestionLinkItem href={t1} groupLabel={t2} showDivider={showDivider} onNavigate={onNavigate} dataTracking={t3}>{t5}{t8}{t9}</SuggestionLinkItem>;
    $[23] = onNavigate;
    $[24] = showDivider;
    $[25] = t1;
    $[26] = t2;
    $[27] = t3;
    $[28] = t5;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
};